// Form newsletter condiviso (snippet newsletter-signup-form).
// Iscrive tramite il form 'customer' di Shopify ed emette 'newsletter:subscribed' al successo.
if (!customElements.get('newsletter-signup')) {
  class NewsletterSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-signup-form]');
      this.emailInput = this.querySelector('[data-signup-email]');
      this.privacyInput = this.querySelector('[data-signup-privacy]');
      this.marketingInput = this.querySelector('[data-signup-marketing]');
      this.tagsInput = this.querySelector('[data-signup-tags]');
      this.errorEl = this.querySelector('[data-signup-error]');
      this.submitBtn = this.querySelector('[data-signup-submit]');
      this.formWrapper = this.querySelector('[data-signup-form-wrapper]');
      this.successEl = this.querySelector('[data-signup-success]');
      this.messages = JSON.parse(this.querySelector('[data-signup-messages]').textContent);
      this.baseTags = this.tagsInput.value;

      this.form.addEventListener('submit', this.onSubmit.bind(this));

      // Ritorno da un invio classico: esito renderizzato dal server
      const result = this.querySelector('[data-signup-result]');
      const serverError = result?.textContent.trim().replace(/\s+/g, ' ');
      if (result?.hasAttribute('data-posted')) {
        this.formWrapper.classList.add('invisible');
        this.successEl.classList.remove('hidden');
        this.notifySubscribed();
      } else if (serverError) {
        this.showError(serverError);
        window.clearPendingNewsletterSubscription?.();
      }
    }

    get formLocation() {
      if (this.dataset.formLocation) return this.dataset.formLocation;
      if (this.closest('newsletter-popup')) return 'popup';
      return 'landing';
    }

    get subscribed() {
      return !this.successEl.classList.contains('hidden');
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.classList.toggle('hidden', !message);
    }

    notifySubscribed(detail = {}) {
      this.dispatchEvent(new CustomEvent('newsletter:subscribed', {
        bubbles: true,
        detail: {
          formLocation: this.formLocation,
          ...detail
        }
      }));
    }

    // Invio classico con evento 'submit': permette al captcha di Shopify (hCaptcha) di aggiungere il token
    submitNatively() {
      this.nativeSubmit = true;
      this.form.requestSubmit();
    }

    async onSubmit(event) {
      if (this.nativeSubmit) return;
      event.preventDefault();
      this.showError('');

      const email = this.emailInput.value.trim();
      if (!email || !this.emailInput.checkValidity()) {
        this.showError(this.messages.invalidEmail);
        return;
      }
      if (
        (this.privacyInput && !this.privacyInput.checked) ||
        (this.marketingInput && this.marketingInput.required && !this.marketingInput.checked)
      ) {
        this.showError(this.messages.consent);
        return;
      }

      // Salva nei dati in sospeso per eventuale redirect a /challenge
      window.savePendingNewsletterSubscription?.(email, this.formLocation);

      const tags = [this.baseTags];
      if (this.marketingInput?.checked && this.messages.marketingTag) tags.push(this.messages.marketingTag);
      this.tagsInput.value = tags.filter(Boolean).join(',');

      this.submitBtn.disabled = true;

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
        });

        // Shopify richiede un captcha: si procede con l'invio classico del form
        if (response.url.includes('/challenge')) {
          this.submitNatively();
          return;
        }

        if (!response.url.includes('customer_posted=true')) {
          // Nessun redirect: Shopify ha restituito la pagina con l'esito nel form
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const result = doc.querySelector(`#${CSS.escape(this.form.id)} [data-signup-result]`);
          const serverError = result?.textContent.trim().replace(/\s+/g, ' ');

          if (serverError) {
            console.warn('Newsletter: errore Shopify', serverError);
            this.showError(serverError);
            window.clearPendingNewsletterSubscription?.();
            return;
          }
          if (!result?.hasAttribute('data-posted')) {
            // Invio AJAX rifiutato (es. 400 per captcha/bot protection): invio classico del form,
            // al ricaricamento lo stato di successo viene mostrato dal server
            console.warn(`Newsletter: risposta ${response.status}, invio classico del form`);
            this.submitNatively();
            return;
          }
        }

        this.formWrapper.classList.add('invisible');
        this.successEl.classList.remove('hidden');
        this.form.reset();

        if (window.pushNewsletterSubscriptionDataLayer) {
          await window.pushNewsletterSubscriptionDataLayer({
            email: email,
            formLocation: this.formLocation
          });
        }
        window.clearPendingNewsletterSubscription?.();
        this.notifySubscribed({ email });
      } catch (error) {
        console.error(error);
        this.showError(this.messages.error);
        window.clearPendingNewsletterSubscription?.();
      } finally {
        this.submitBtn.disabled = false;
      }
    }
  }

  customElements.define('newsletter-signup', NewsletterSignup);
}
